import Icon from "assets/icons";
import { ProgramHeaderItemState } from "./enum";
import TradeProgramStatus from "shared/enums/TradeProgramStatus";
import MeetupProgramStatus from "shared/enums/MeetupProgramStatus";
import BuyersProgramStatus from "shared/enums/BuyersProgramStatus";
import { ProgramStatusType } from "shared/types/ProgramStatusType";
import TabletalkProgramStatus from "shared/enums/TabletalkProgramStatus";
import AssociatedProgramStatus from "shared/enums/AssociateProgramStatus";
import InPersonMeetupProgramStatus from "shared/enums/InPersonMeetupProgramStatus";
import { ProgramHeaderItem, ProgramHeaderItemWithStatus } from "./types";

export function getStagesForProgramHeader({
  currentProgramStage,
  programHeaderStagesList,
  skippedStages
}: {
  currentProgramStage: ProgramStatusType;
  programHeaderStagesList: Array<ProgramHeaderItem<ProgramStatusType>>;
  skippedStages: Array<ProgramStatusType>;
}): Array<ProgramHeaderItemWithStatus<ProgramStatusType>> {
  //   remove skipped stages &
  //   remove program header item if stages included for that item are empty
  //        as this means we don't want to show that program stage header
  const filteredProgramHeaderStagesList = programHeaderStagesList
    .map((o: ProgramHeaderItem<ProgramStatusType>) => ({
      ...o,
      stagesIncluded: o.stagesIncluded.filter(stage => !skippedStages.includes(stage))
    }))
    .filter((o: ProgramHeaderItem<ProgramStatusType>) => o.stagesIncluded.length);
  //   find the current stage display order
  //   todo:rr if because of some invalid config is present then throw error or show all stages as completed/locked?
  //          currently displaying all as completed
  const currentStageDisplayOrder =
    programHeaderStagesList.find(o => o.stagesIncluded.includes(currentProgramStage))?.displayOrder || 0;
  const isProgramCompleted = [
    InPersonMeetupProgramStatus.COMPLETED,
    BuyersProgramStatus.COMPLETED,
    MeetupProgramStatus.COMPLETED,
    TradeProgramStatus.COMPLETED,
    TabletalkProgramStatus.COMPLETED,
    AssociatedProgramStatus.COMPLETED
  ].includes(currentProgramStage);
  //   add status for header
  return filteredProgramHeaderStagesList.map((o: ProgramHeaderItem<ProgramStatusType>) => {
    const itemStatus = getProgramHeaderItemStatus(o.displayOrder, currentStageDisplayOrder, isProgramCompleted);
    return {
      ...o,
      enabled: o.enabled ?? itemStatus !== ProgramHeaderItemState.NOT_YET_TIME,
      active: o.stagesIncluded.includes(currentProgramStage),
      status: itemStatus
    };
  });
}

function getProgramHeaderItemStatus(
  itemDisplayOrder: number,
  currentStageDisplayOrder: number,
  isProgramCompleted: boolean
) {
  return itemDisplayOrder < currentStageDisplayOrder || isProgramCompleted
    ? ProgramHeaderItemState.COMPLETED
    : itemDisplayOrder > currentStageDisplayOrder
    ? ProgramHeaderItemState.NOT_YET_TIME
    : ProgramHeaderItemState.ON_GOING;
}

export function getIconForHeader(state: ProgramHeaderItemState) {
  if (state === ProgramHeaderItemState.COMPLETED) {
    return <Icon.CheckCircle />;
  } else if (state === ProgramHeaderItemState.NOT_YET_TIME) {
    return <Icon.ClosedLock />;
  }
  // for stage that is running we don't want to show any icon
  return null;
}
